import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import RiskTypeDropdown from './RiskTypeDropdown';
import ToggleSwitch from '../ToggleSwitch';

export default class CategoryListRow extends Component {

    handleEditRisk = (riskType) => {
        this.props.onEditRisk(this.props.id, riskType, this.props.riskType);
    }

    handleIsAvailableChange = (isAvailable) => {
        this.props.onEditIsAvailable(this.props.id, isAvailable, this.props.isAvailable);
    }

    handleIsActiveChange = (isActive) => {
        this.props.onEditIsActive(this.props.id, isActive, this.props.isActive);
    }

    handleHighlightWhenFoundChange = (highlightWhenFound) => {
        this.props.onEditHighlightWhenFound(this.props.id, highlightWhenFound, this.props.highlightWhenFound);
    }

    handleWarnWhenMissingChange = (warnWhenMissing) => {
        this.props.onEditWarnWhenMissing(this.props.id, warnWhenMissing, this.props.warnWhenMissing);
    }

    render() {
        return (
            <tr id={`row-${this.props.index}`} className="category-row" key={this.props.code}>
                <td><Link to={`/dashboard/themes/${this.props.packageId}/concept/${this.props.code}`}>{this.props.name}</Link></td>
                <td>{this.props.code}</td>
                <td>
                    <RiskTypeDropdown risk={this.props.riskType} onChange={this.handleEditRisk} />
                </td>
                <td>
                    <ToggleSwitch initialValue={this.props.isAvailable} onChange={this.handleIsAvailableChange} />
                </td>
                <td>
                    <ToggleSwitch initialValue={this.props.isActive} onChange={this.handleIsActiveChange} />
                </td>
                <td>
                    <ToggleSwitch initialValue={this.props.highlightWhenFound} onChange={this.handleHighlightWhenFoundChange} />
                </td>
                <td>
                    <ToggleSwitch initialValue={this.props.warnWhenMissing} onChange={this.handleWarnWhenMissingChange} />
                </td>
            </tr>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CategoryView/CategoryListRow.js